// extracted by mini-css-extract-plugin
export var menu = "menu-module--menu--ef81b";
export var open = "menu-module--open--c8152";